const autocompleteFormActions = {
  accountable: 'Responsables',
  helperText: 'Cantidad máxima de responsables:',
};

export default autocompleteFormActions;
